var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"button-close",class:_vm.ColorFromProps,attrs:{"type":"button","aria-label":"Close"}},[_c('icon-cross',{staticClass:"button-close__icon",attrs:{"focusable":"false"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }